export const makeKey = (mobileNumber, programCode) => `${mobileNumber}-${programCode}`;
